export { UpgradeItemV2 } from './UpgradeItemV2';
export type { UpgradeItemV2Props, UpgradeOriginalRoom } from './UpgradeItemV2.types';
